<template>
  <div>
    <div class="row" style="background-color: white !important">
      <div class="col pt-3" style="background-color: #333">
        <p class="text-md-right text-center">
          <a id="whatsapp" :href="wp()" target="_blank">
            <i class="fab fa-whatsapp"></i> WhatsApp: <b>{{ phone }}</b>
          </a>
        </p>
      </div>
    </div>
    <nav class="navbar navbar-expand-lg navbar-light">
      <router-link to="/" class="navbar-brand" tag="a">
        <img
          src="/src/assets/logo.png"
          width="200"
          height="150"
          alt="Ayancık Adak"
        />
      </router-link>
      <!-- Mobil menu button -->
      <a
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#menu"
        aria-controls="menu"
        aria-expanded="true"
      >
        <span class="navbar-toggler-icon" data-active-class="custom-icon">
        </span>
      </a>
      <!-- Mobil menu button -->

      <div id="menu" class="collapse navbar-collapse">
        <ul class="navbar-nav mx-auto" v-scrollanimation>
          <router-link
            v-for="item in menus"
            :key="item.id"
            tag="li"
            class="nav-item"
            :to="item.router_to"
            active-class="active"
            exact
          >
            <a class="nav-link">{{ item.menu_ad | upperCase }} </a>
            <span id="nav-link-border"></span>
          </router-link>
        </ul>
      </div>
    </nav>
    <hr />
  </div>
</template>
<script>
import json from "../menus.json";
export default {
  data() {
    return {
      menus: json,
      phone: "+90 532 615 8788",
    };
  },
  methods: {
    wp() {
      return "https://wa.me/905326158788";
    },
  },
  filters: {
    upperCase(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  watch: {
    $route() {
      $("#menu").collapse("hide");
    },
  },
};
</script>

<style scoped>

.navbar-toggler {
  border: 2px solid rgb(67, 202, 101);
}
.navbar-brand {
  margin-top: 20px;
  margin-bottom: 15px;
  margin-left: 20px;
  padding: 0;
  transition: transform 0.3s ease-in-out;
}
/* .navbar-brand:hover {
  transform: scale(1.1);
  transition: transform 0.3s ease-in-out;
} */
#whatsapp {
  /* color: #499176; */
  color: #fff;
  text-decoration: none;
  transition: all 0.4s ease;
}
#whatsapp:hover {
  color: #22b982;
  text-decoration: none;
  transition: all 0.4s ease;
  font-weight: bolder;
}
nav {
  margin-top: -10px;
  font-size: 15px;
  letter-spacing: 1px;
}
.nav-item {
  margin-left: 40px !important;
  margin-right: 25px !important;
  transition: transform 0.3s ease-out;
}
.nav-item:hover {
  transition: transform 0.3s ease-out;
  transform: scale(1.1);
}
.nav-link + #nav-link-border {
  display: block;
  border-bottom: solid 3px #38bb6a;
  width: 0;
  -webkit-transition: width 250ms ease-in-out;
  transition: width 250ms ease-in-out;
}
.nav-link:hover + #nav-link-border {
  width: 100%;
  -webkit-transition: width 250ms ease-in-out;
  transition: width 250ms ease-in-out;
}
.nav-link {
  color: #4b5d67 !important;
  transition: transform 0.3s ease-out;
  margin-left: -7px !important;
  margin-top: 15px !important;
}
.nav-link:hover {
  color: #499176 !important;
}
i {
  font-size: 20px;
}

.before-enter {
  opacity: 0;
  transition: all 1s cubic-bezier(0.42, 0.01, 0.51, 1.49);
}
.enter {
  opacity: 1;
}

@media only screen and (max-width: 399px) {
  .navbar-toggler {
    margin-left: auto;
    margin-right: auto;
  }
  .navbar-brand {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue